import styled from 'styled-components'

import { cn } from 'utils/classMerge'

import { fonts, palette } from '../../styles/variables'

const Label = styled.label((props) => ({
  height: props.height,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  cursor: 'pointer',
  userSelect: 'none',
  '& input': {
    position: 'absolute',
    opacity: 0,
    cursor: 'pointer',
  },

  '& input:checked ~ .uber-checkmark:after': {
    display: props.disabled ? 'none' : 'block',
  },

  '& .uber-checkmark': {
    ':after': {
      left: '4px',
      top: '1px',
      width: '4px',
      height: '7px',
      border: `1px solid ${palette.orange}`,
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)',
    },
  },

  '& .label': {
    marginLeft: '28px',
    color: props.disabled
      ? palette.darkGray50
      : props.color || palette.darkGray,
    fontFamily: props.fontFamily || fonts.primary,
    fontSize: props.fontSize || '14px',
  },
}))

const Checkmark = styled.span((props) => ({
  position: 'absolute',
  height: '16px',
  width: '16px',
  border: props.isHistoricalSearch ? '' : `1px solid ${palette.lightGray}`,
  backgroundColor: palette.white,
  ':after': {
    content: `''`,
    position: 'absolute',
    display: 'none',
  },
}))

const CheckBox = ({
  height = 'auto',
  disabled,
  checked,
  onChange = () => ({}),
  style,
  ...props
}) => {
  return (
    <Label
      data-testid={props.testId}
      height={height}
      disabled={disabled}
      fontFamily={props.fontFamily}
      fontSize={props.fontSize}
      color={props.color}
      style={style}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <Checkmark
        className={cn('uber-checkmark', {
          'tw-border tw-border-solid tw-rounded tw-border-zinc-300':
            props.isHistoricalSearch,
          'tw-rounded-none': !props.isHistoricalSearch,
        })}
        isHistoricalSearch={props.isHistoricalSearch}
      />
      <span className="label">{props.children}</span>
    </Label>
  )
}

export default CheckBox
